'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _getLuminance = require('./getLuminance');

var _getLuminance2 = _interopRequireDefault(_getLuminance);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var allowedContrastRatioDecimalPlaces = 2;

exports.default = function (color1, color2) {
  var lum1 = (0, _getLuminance2.default)(color1);
  var lum2 = (0, _getLuminance2.default)(color2);
  var contrastRatio = (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);
  return Number(contrastRatio.toFixed(allowedContrastRatioDecimalPlaces));
};